import { HTMLAttributes, Ref } from 'react';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';

import { media } from '../../media';

type VerticalPadding = 'lg' | 'sm' | 'none';

type Props = HTMLAttributes<HTMLDivElement> & {
  borderBottom?: boolean;
  verticalPadding?: VerticalPadding;
  ref?: Ref<HTMLDivElement>;
};

function getVerticalPadding(verticalPadding: VerticalPadding | undefined) {
  if (verticalPadding === 'none') return 0;
  if (verticalPadding === 'sm') return 16;
  return 24;
}

const Root = styled.div<{ $borderBottom: number; $verticalPadding: number }>`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: ${({ $verticalPadding }) => $verticalPadding}px;
  padding-bottom: ${({ $verticalPadding }) => $verticalPadding}px;
  border: 0 solid ${color.border};
  border-bottom-width: ${({ $borderBottom }) => $borderBottom}px;

  @media ${media.sm} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export function ContentContainer({ borderBottom, verticalPadding, ref, ...props }: Props) {
  return (
    <Root
      {...props}
      $borderBottom={borderBottom ? 1 : 0}
      $verticalPadding={getVerticalPadding(verticalPadding)}
      ref={ref}
    />
  );
}
